export function getLatestObjectsWithHistory(objects) {
    const objectsWithoutPredecessors = objects.filter((object) => !object.predecessor);
    const successorMap = objects.reduce((map, object) => ({ ...map, ...(object.predecessor ? { [object.predecessor._id]: object } : {}) }), {});
    const latestObjects = objectsWithoutPredecessors.map((objectsWithoutPredecessor) => {
        let currentObject = objectsWithoutPredecessor;
        let nextObject = undefined;
        const history = [];
        do {
            nextObject = successorMap[currentObject._id];
            if (nextObject) {
                history.push(currentObject);
                currentObject = nextObject;
            }
        } while (nextObject);
        return { data: currentObject, history };
    });
    return latestObjects;
}
export function findPredecessor(objects, object) {
    if (!object.predecessor) {
        return undefined;
    }
    const predecessorId = object.predecessor._id;
    return objects.find((element) => element._id === predecessorId);
}
export function findSuccessor(objects, object) {
    return objects.find((element) => element.predecessor && element.predecessor._id === object._id);
}
export function findSuccessorEntity(entities, entity) {
    if (!entity.successor) {
        return undefined;
    }
    const successorId = entity.successor._id;
    return entities.find((element) => element._id === successorId);
}
//# sourceMappingURL=VersioningUtils.js.map